import { API_HOST } from "$lib/environment";
import { EventSource } from "eventsource";
import type { ImportStatusMessage } from "$lib/models/ImportStatusMessage";
import { ImportMessageType } from "$lib/models/ImportMessageType";
import { authenticatedFetch } from "$lib/authenticatedFetch";

export type Unsubscriber = () => void;
export function subscribeToServerEvents(
  handler: (event: ImportStatusMessage) => void,
  diffId: string,
): Unsubscriber {
  const eventSource = new EventSource(`${API_HOST}/diff/${diffId}/status`, {
    fetch: (input, init) =>
      authenticatedFetch(input as string, {
        ...init,
        credentials: "include",
      }),
  });

  eventSource.onmessage = (e) => {
    try {
      const parsed: ImportStatusMessage = JSON.parse(e.data);
      if (
        parsed.type == ImportMessageType.FAILED ||
        parsed.type == ImportMessageType.COMPLETED
      ) {
        eventSource?.close();
      }
      handler(parsed);
    } catch {
      console.error("Invalid JSON in SSE:", e.data);
    }
  };

  eventSource.onerror = (e) => {
    console.error("SSE error:", e);
    handler({
      diffId: "",
      type: ImportMessageType.FAILED,
      message: "[error] SSE connection lost",
      timestamp: new Date().toISOString(),
    });
  };

  return () => {
    eventSource.close();
  };
}
